var config = (config = require('../../../config.json'));
export default config;
